import {
  CheckCircleOutline,
  ErrorOutline,
  PlayCircleOutline,
} from "@mui/icons-material";
import PauseCircleOutlined from "@mui/icons-material/PauseCircleOutlined";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import { Status } from "../../interfaces/common";

function StatusIcon({ status }: { status: Status }) {
  if (status === Status.PENDING) {
    return (
      <Tooltip title="Traitement en attente">
        <Chip
          icon={<PauseCircleOutlined color="warning" />}
          label={"En attente"}
          color={"warning"}
          variant="outlined"
        />
      </Tooltip>
    );
  } else if (status === Status.IN_PROGRESS) {
    return (
      <Tooltip title="Traitement en cours">
        <Chip
          icon={<PlayCircleOutline color="info" />}
          label={"En cours"}
          color={"info"}
          variant="outlined"
        />
      </Tooltip>
    );
  } else if (status === Status.ERROR) {
    return (
      <Tooltip title="Une erreur est survenue">
        <Chip
          icon={<ErrorOutline color="error" />}
          label={"Erreur"}
          color={"error"}
          variant="outlined"
        />
      </Tooltip>
    );
  } else if (status === Status.DONE) {
    return (
      <Tooltip title="Traitement terminé">
        <Chip
          icon={<CheckCircleOutline color="success" />}
          label={"Terminé"}
          color={"success"}
          variant="outlined"
        />
      </Tooltip>
    );
  } else {
    return <Chip label={status} color={"default"} />;
  }
}

export default StatusIcon;
